var CollectionFilter = React.createClass({
  propTypes: {
    customCollections: React.PropTypes.array.isRequired,
    selectedCollections: React.PropTypes.arrayOf(React.PropTypes.string),
    onCollectionsChanged: React.PropTypes.func,
	showCollectionFilter: React.PropTypes.bool
  },
  getDefaultProps() {
    return {
      selectedCollections: [],
	  showCollectionFilter: false
    }
  },
  collectionClicked(code) {
    let checkedCollections = this.props.selectedCollections;
    let isSelected = this.isCollectionSelected(code);

    if (!isSelected) {
      checkedCollections.push(code);
    } else {
      checkedCollections = checkedCollections.filter(val => val != code);
    }

    if (this.props.onCollectionsChanged) {
      this.props.onCollectionsChanged(checkedCollections);
    }
  },
  isCollectionSelected(code) {
    return this.props.selectedCollections.indexOf(code) != -1;
  },
  getItem(coll) {
	let productLabel = coll.code.replace("custom_", "productLabel_");

    return (
      <li className="filter__item" key={coll.code}>
        <RACheck label={Labels.getLabel(productLabel)}
          value={coll.code}
          isChecked={this.isCollectionSelected(coll.code)}
          onClick={this.collectionClicked} />
      </li>
    )
  },
  render() {
    let { showCollectionFilter } = this.props;
    if (!showCollectionFilter || this.props.customCollections.length == 0) {
      return <span />
    }
let selectedItems = [];
    let otherItems = [];

	for (let i = 0; i <  this.props.customCollections.length; i++) {
		if (this.isCollectionSelected(this.props.customCollections[i].code)) {
			selectedItems.push(this.getItem(this.props.customCollections[i]));
		} else {
			otherItems.push(this.getItem(this.props.customCollections[i]));
		}
	}

    return (
       <BrowseFilter title={this.props.title ? this.props.title : Labels.getLabel("Collections")} filterType="filter-type__collection" ariaLabel="Solution Collections filter" isOpen={this.props.isOpen}>
        <CollapsingFilterList
            defaultItems={selectedItems}
            displayBeforeFold="8"
            items={otherItems}
          />
      </BrowseFilter>
    )
  }
});